module.exports = __webpack_public_path__ + "img/Flag_of_Zambia.ddd96ecf.svg";